import { BaseService } from "./common/base";
import type { Payment } from "../../../../api/src/payment/models/payment";
import type { Appointment } from "../../../../api/src/appointment/entities/appointment.entity";
import type { UpdatePaymentDto } from "../../../../api/src/payment/dto/update-payment.dto";
import { CreateAppointmentDto } from "../../../../api/src/appointment/dto/create-appointment.dto";

export class AppointmentService extends BaseService<
  Appointment,
  Partial<Appointment>,
  CreateAppointmentDto,
  Partial<Appointment>,
  Appointment[]
> {
  constructor() {
    super("appointment");
  }

  public getLivekitToken(id: string) {
    return this._post(`${id}/livekit-token`);
  }

  public end(id: string, body) {
    return this._post(`/${id}/end`, body);
  }

  public cancel(id: string) {
    return this._post(`/${id}/cancel`);
  }

  public addObservations(id: string, observations: unknown[]) {
    return this._post(`${id}/observations`, { observations });
  }

  public syncTranscription(id: string, transcription: string) {
    return this._post(`${id}/transcription`, { transcription });
  }

  public getAppointmentsByPatientId(patientId: string, params) {
    return this._get(`/patient/${patientId}`, { params });
  }

  public getLatestFulfilled() {
    return this._get(`/latest-fulfilled`);
  }

  public requestPayment(
    id: string,
    amount: { value: number; currency: string }
  ): Promise<{
    paymentReconciliation: Payment;
    stripePaymentIntent: { clientSecret: string };
  }> {
    return this._post(`${id}/payment`, amount);
  }

  public updatePayment(
    id: string,
    payload: UpdatePaymentDto
  ): Promise<Payment> {
    return this._patch(`${id}/payment`, payload);
  }

  public create(data: CreateAppointmentDto): Promise<Appointment[]> {
    return this._post("/", data);
  }

  public contextualizeTranscription(
    id: string,
    transcription: string,
    participantsRoles?: Record<string, string>
  ): Promise<{ summary: { history: string; clinical_examination: string; conclusion: string } | null }> {
    return this._post(`${id}/contextualize-transcription`, { transcription, participantsRoles });
  }

  public syncTranscriptionSummary(
    id: string,
    transcriptionSummary: string
  ): Promise<any> {
    return this._post(`${id}/transcription-summary`, { transcriptionSummary });
  }
}
